// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/mission-execution/shared/ExecutionMetricTile.jsx

import React from "react";
import { Metric } from "../../../design-system/components";

function displayValue(value, fallback = "—") {
  if (value === null || value === undefined || value === "") return fallback;
  if (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  ) {
    return String(value);
  }
  if (Array.isArray(value)) {
    const text = value
      .map((item) => displayValue(item, ""))
      .filter(Boolean)
      .join(", ");
    return text || fallback;
  }
  if (typeof value === "object") {
    const candidate =
      value.label ||
      value.title ||
      value.name ||
      value.value ||
      value.status ||
      value.state ||
      value.id;

    if (
      candidate !== undefined &&
      candidate !== null &&
      candidate !== value
    ) {
      return displayValue(candidate, fallback);
    }
  }
  return fallback;
}

function toneFromColor(color) {
  const value = String(color || "").toLowerCase();

  if (value.includes("4fd28e") || value.includes("34d399")) {
    return "success";
  }
  if (value.includes("ff7b7b") || value.includes("f87171")) {
    return "danger";
  }
  if (value.includes("ffcc66") || value.includes("fbbf24")) {
    return "warning";
  }
  if (value.includes("60a5fa") || value.includes("6aa8ff")) {
    return "informational";
  }
  return "neutral";
}

export default function ExecutionMetricTile({
  label,
  value,
  sub,
  color = "#60a5fa",
}) {
  return (
    <Metric
      label={displayValue(label, "Metric")}
      value={displayValue(value)}
      supportingText={sub ? displayValue(sub, "") : null}
      tone={toneFromColor(color)}
      size="compact"
      className="execution-metric-tile"
    />
  );
}
